import api from '@pray/shared/utils/api';
import type { CatalogItemListResponse } from './types';
type Props = { artistId: string; catalogId: string; q?: string; limit?: number; cursor?: string | null };
export async function getCatalogItems({ artistId, catalogId, q, limit = 25, cursor }: Props) {
  if (!artistId) throw new Error('Artist ID is required');
  const params: Record<string, string | number> = { limit };
  if (q) params.q = q;
  if (cursor) params.cursor = cursor;
  // Unwrap the backend envelope ({ responded_at, object, data }) one level — see getCatalogs.ts.
  const res = await api.executeGetRequest<{ data: CatalogItemListResponse }>(
    `/web/studio/artists/${artistId}/catalogs/${catalogId}/items`, params);
  return res.data.data;
}
